import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print-purchase-order',
  templateUrl: './print-purchase-order.component.html',
  styleUrls: ['./print-purchase-order.component.css']
})
export class PrintPurchaseOrderComponent implements OnInit {
 
  constructor(private activatedRoute: ActivatedRoute,public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
       this.FilterModel.POID =  params['POID'];
       this.FilterModel.IsActive =  params['IsActive'];
      
      this.GetAllPurchaseOrder ();

    });
  }
 
  FilterModel = {
    POID:0,
    IsActive : false,   
   
}

  POList:any;
  POItemList:any;
  POLocationList:any;
  BranchDetails:any;
  TotalAmount=0;
  Integer:any;
  decimal:any;
GetAllPurchaseOrder  () { 
    this.spinnerService.show();
  this.stockService.GetAllPurchaseOrder(JSON.stringify(this.FilterModel)).subscribe( (response)=> {
           this.spinnerService.hide();

          this.POList = response.POList[0];
          this.POItemList = response.POList[0].ItemList;
          this.POLocationList = response.POLocationList;
          this.BranchDetails = response.BranchDetails;
           var POLocationIDs = response.POList[0].POLocation != null ? response.POList[0].POLocation.split(',') : '';
           for (var i = 0; i <this.POLocationList.length; i++) {
              this.POLocationList[i].IsSelect = false;
               for (var j = 0; j < POLocationIDs.length; j++) {
                   if (POLocationIDs[j] ==this.POLocationList[i].ItemId) {
                      this.POLocationList[i].IsSelect = true;
                       break;
                   }
               }
           }
           for (var i = 0; i <this.POItemList.length; i++) {
              this.POItemList[i].Amount =this.POItemList[i].Quantity *this.POItemList[i].UnitPrice;
           }
          this.TotalAmount = parseFloat(this.POList.BillAmount) - parseFloat(this.POList.DiscountAmount);
           var str = (this.globalHelper.Decimal(this.TotalAmount)).toString().trim();
           var substr = str.split('.');
          this.Integer = substr[0];

           var p = (substr.length == 2 ? substr[1] : 0);
           if (p.length == 1) {
              this.decimal = p + '00';
           }
           else if (p.length == 2) {
              this.decimal = p + '0';
           }
           else {
              this.decimal = 0;
           }

           setTimeout( () =>{          
               window.print();
           }, 300);
         
            });
};
  ngOnInit() {
  }

}
